export default __webpack_public_path__ + "static/media/verifiedGogetters.c5fdd1cd.svg";